import type React from "react"
import { Navigate, Outlet, useLocation } from "react-router"

import { DataGuard } from "@/components/data-guard"
import { SitePath } from "@/models/route"
import { useUrl } from "@/utils/url"

export const SitesIndexRoute: React.FC = () => {
  const { sitesPath } = useUrl()
  const { pathname } = useLocation()
  if (pathname === sitesPath || pathname === `${sitesPath}/`) {
    return <Navigate to={SitePath.Overview} replace={true} />
  }

  return (
    <DataGuard>
      <Outlet />
    </DataGuard>
  )
}
